import { style } from 'typestyle'
export const pb20 = style({ paddingBottom: '20px' })
